'use client';
'use strict';

var jsxRuntime = require('react/jsx-runtime');
var Formie = require('../components/Formie/Formie.js');
require('../components/Recaptcha/googleRecaptchaVerify.js');
require('@mui/material');
var RecaptchaProvider = require('../components/Recaptcha/RecaptchaProvider.js');
require('react');
require('react-google-recaptcha-v3');
var useFormieCaptchaFragments = require('../components/Recaptcha/useFormieCaptchaFragments.js');
var ErrorFallback = require('../ErrorFallback/ErrorFallback.js');
var LoadingFallback = require('../LoadingFallback/LoadingFallback.js');

function Form(props) {
    const { form, defaultValues, loading, error, disableRecaptchaProvider, hideRecaptchaBadge, loadingFallback, errorFallback } = props;
    const gRecaptchaSettings = useFormieCaptchaFragments({
        data: form == null ? void 0 : form.captchas
    });
    if (loading) {
        return /*#__PURE__*/ jsxRuntime.jsx(jsxRuntime.Fragment, {
            children: loadingFallback != null ? loadingFallback : /*#__PURE__*/ jsxRuntime.jsx(LoadingFallback, {})
        });
    }
    if (error || !form) {
        return /*#__PURE__*/ jsxRuntime.jsx(jsxRuntime.Fragment, {
            children: errorFallback != null ? errorFallback : /*#__PURE__*/ jsxRuntime.jsx(ErrorFallback, {})
        });
    }
    const formOutput = /*#__PURE__*/ jsxRuntime.jsx(Formie, {
        form: form,
        gRecaptchaSettings: gRecaptchaSettings,
        showGRecaptchaPolicy: hideRecaptchaBadge,
        defaultValues: defaultValues
    });
    return disableRecaptchaProvider ? formOutput : /*#__PURE__*/ jsxRuntime.jsx(RecaptchaProvider, {
        reCaptchaKey: gRecaptchaSettings.gRecaptchaSiteKey,
        hideBadge: hideRecaptchaBadge,
        children: formOutput
    });
}

module.exports = Form;
